import React from 'react'

import HeaderWidget from '../../../../../components/atoms/HeaderWidget'

const Overdue: React.FC = () => {
  return (
    <HeaderWidget
      title='Overdue'
      information='This metric measures the number of tasks that have been completed past their due date.'
    >
      -
    </HeaderWidget>
  )
}

export default Overdue
